module.exports = __webpack_public_path__ + "static/MuseoSans-300-08235e1c1f8a5f63f7ee5264591c87c3.woff";